import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useTour } from './TourContext';

const DemoBanner: React.FC = () => {
  const { t } = useLanguage();
  const { isSampleMode } = useTour();
  if (!isSampleMode) return null;

  return (
    <div
      className="sticky top-0 z-40 mb-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-2.5 text-sm text-amber-900"
      role="status"
      data-tour="demo-banner"
    >
      <span className="font-semibold">{t('tour.demo.banner.title')}</span>
      <span className="mx-1.5 text-amber-700">·</span>
      <span>{t('tour.demo.banner.body')}</span>
    </div>
  );
};

export default DemoBanner;
